/* eslint-disable react/prop-types */ // TODO: add props
import Immutable from 'immutable';
import IPT from 'react-immutable-proptypes';
import PT from 'prop-types';
import cx from 'classnames';
import ChunkBookmark from 'edrolo/domains/bookmarks/components/ChunkBookmark';
import ShareLink from 'edrolo/components/common/ShareLink';
import MaterialsPopover from '../MaterialsPopover';
import SpeedControlButton from 'edrolo/domains/video/components/SpeedControlButton';
import {
  useAttachments,
  ATTACHMENT_TYPE,
  attachmentPropTypes,
} from 'edrolo/domains/attachments';
import { Icon } from 'edrolo-style-guide';
import s from './ToolbarSlideshow.scss';

// Keep data hook provision separate to enable simplified stories
// wrapper is returned as default export
export const ToolbarSlideshow = (props) => {
  const { data: attachments } = useAttachments(
    props.classId,
    ATTACHMENT_TYPE.LESSON,
    props.lessonId
  );

  return (
    <ToolbarSlideshowPresentational {...props} attachments={attachments} />
  );
};

export const ToolbarSlideshowPresentational = ({
  chunkId,
  classId,
  attachments,
  playbackRate,
  onVideoSpeedChange,
  hasVideo,
  disableBookmarks = false,
  disableSharelinks = false,
}) => {
  return (
    <div className={s.toolbar}>
      <div className={s.toolbarItem}>
        <MaterialsPopover
          disabled={attachments.isEmpty()}
          attachments={attachments.toList()}
          label="Download resources"
          iconName="download"
        />
      </div>

      {/* TODO: remove after rolling out new course UX */}
      {/* disable bookmarks for users of the new Course Portal, which doesn't support bookmarks */}
      {!disableBookmarks && (
        <div className={cx(s.toolbarItem)}>
          <ChunkBookmark
            chunkId={chunkId}
            fullButton
            disabled={disableBookmarks}
          />
        </div>
      )}

      <div className={s.toolbarItem}>
        <ShareLink
          title="To share this chunk, copy and paste this link:"
          model="chunk"
          objectId={chunkId}
          classId={classId}
          shareType="chunkview"
          origin="chunkview_v2"
        >
          <button
            className={s.button}
            data-test="shareLink"
            disabled={disableSharelinks}
          >
            <Icon name="link" />
            Link to chunk
          </button>
        </ShareLink>
      </div>

      {hasVideo && (
        <div className={s.toolbarItem}>
          <div className={s.speedControlButton}>
            <SpeedControlButton
              playbackRate={playbackRate}
              onChangeSpeed={onVideoSpeedChange}
            />
          </div>
        </div>
      )}
    </div>
  );
};

ToolbarSlideshowPresentational.defaultProps = {
  attachments: Immutable.Map(),
};

ToolbarSlideshow.propTypes = {
  chunkId: PT.number,
  classId: PT.string,
  lessonId: PT.number.isRequired,
  playbackRate: PT.number,
  attachments: IPT.mapOf(attachmentPropTypes, PT.string),
  disableBookmarks: PT.bool,
  disableSharelinks: PT.bool,
};
